import { render, staticRenderFns } from "./solutionDetail.vue?vue&type=template&id=41617f8c&scoped=true"
import script from "./solutionDetail.vue?vue&type=script&lang=js"
export * from "./solutionDetail.vue?vue&type=script&lang=js"
import style0 from "./solutionDetail.vue?vue&type=style&index=0&id=41617f8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41617f8c",
  null
  
)

export default component.exports